<template>
  <el-col>
    <el-collapse v-model="barcodeUser.filtersOpen">
      <el-collapse-item
        :title="$t('barCodeUserType.searchSection')"
        name="search-section"
        id="search-section">
        <el-form
          :model="searchForm"
          ref="searchForm"
          id="search"
          label-position="right"
          size="mini"
          class="search-section-form"
          inline>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('barCodeUserType.userId')" prop="id">
                <el-input
                  v-model="searchForm.userId"
                  ref="filter-id"
                  v-alphanumeric-validation
                  maxlength="5"
                  clearable
                  @clear="handleSearch"
                  v-on:keyup.enter.native="handleSearch"
                  class="inline-input"
                  id="searchForm-id"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('barCodeUserType.fullName')" prop="fullName">
                <el-input
                  v-model="searchForm.fullName"
                  ref="filter-fullName"
                  v-alphanumeric-validation
                  maxlength="100"
                  clearable
                  @clear="handleSearch"
                  v-on:keyup.enter.native="handleSearch"
                  class="inline-input"
                  id="searchForm-fullName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('barCodeUserType.role')" prop="role">
                <el-select
                  v-model="searchForm.role"
                  id="searchForm-role"
                  ref="filter-role"
                  @change="handleSearch">
                  <el-option
                    v-for="item in roleOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('barCodeUserType.warehouseCode')" prop="warehouse">
                <el-select
                  v-model="searchForm.warehouseId"
                  id="searchForm-warehouse-id"
                  ref="filter-warehouseId"
                  @change="handleSearch">
                  <el-option
                    v-for="item in warehouseOptions"
                    :key="item.id"
                    :label="item.code"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('barCodeUserType.company')" prop="company">
                <el-input
                  v-model="searchForm.company"
                  ref="filter-company"
                  v-alphanumeric-validation
                  maxlength="50"
                  clearable
                  @clear="handleSearch"
                  v-on:keyup.enter.native="handleSearch"
                  class="inline-input"
                  id="searchForm-company"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('barCodeUserType.status')" prop="active">
                <el-select
                  v-model="searchForm.active"
                  id="searchForm-active"
                  ref="filter-active"
                  @change="handleSearch">
                  <el-option
                    v-for="item in activeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24" class="text-align-end">
              <span>
                <el-tooltip
                    class="item"
                    effect="dark"
                    :content="$t('barCodeUserType.search')"
                    placement="top-start">
                  <el-button
                      id="form-search-button"
                      @click="handleSearch"
                      icon="el-icon-search"
                      size="mini"
                      class="button-action-default"></el-button>
                </el-tooltip>
              </span>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </el-col>
</template>

<script>
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';

export default {
  name: 'SearchFilters',
  computed: {
    ...mapGetters(['barcodeUser'])
  },
  data() {
    return {
      searchForm: {
        role: null,
        fullName: '',
        userId: '',
        warehouseId: null,
        active: constants.BAR_CODE_USER.ACTIVE_OPTIONS[1].value
      },
      warehouseOptions: [],
      roleOptions: constants.BAR_CODE_USER.ROLE_OPTIONS,
      activeOptions: constants.BAR_CODE_USER.ACTIVE_OPTIONS
    };
  },
  methods: {
    handleSearch() {
      this.$store.dispatch('barcodeUser/search', this.searchForm);
    }
  },
  mounted() {
    this.$store.dispatch('barcodeUser/setDefaultFilters');
    this.$store.dispatch('warehouse/getWarehouseCodes').then(({ data }) => {
      this.warehouseOptions = data;
      this.warehouseOptions.unshift({
        id: null,
        code: this.$t('common.all')
      });
    });
    this.handleSearch();
  }
};
</script>
